import { TfiAngleRight } from "react-icons/tfi";
import SliderShow from "../../AuctionListing/Slider";
import Container from "../../layout/Container";

const BusinessImageSlider = () => {
  return (
    <div>
      <Container>
        <h2 className="font-pop font-bold text-2xl text-darkGreen mt-10 mb-7">Buz Plumbing</h2>
        <div className="relative h-[576px] w-[1018px] overflow-hidden rounded-md border border-solid border-darkGreen border-opacity-30">
          <div>
            <div className="relative">
              <img
                className="h-[576px] w-[1018px]"
                src="assets/images/auction_listing/auctionimg.png"
                alt="auctionimg"
              />
              <div className="absolute top-[215px] right-4 cursor-pointer rounded-full bg-black bg-opacity-20 py-4 px-4 text-white">
                <TfiAngleRight />
              </div>
            </div>
          </div>
          <div className=" absolute bottom-0 right-0 flex w-full items-center justify-center gap-x-5 bg-white py-7">
            <SliderShow />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BusinessImageSlider;
